import sbjs from "sourcebuster";
import {
  SourcebusterData,
  SourcebusterTrafficInfo,
  TrafficInfo,
} from "./types";

function mapType(type: SourcebusterTrafficInfo["typ"]) {
  if (type === "typein") {
    return "direct";
  }

  return type;
}

function wrapCallback(
  callback: (trafficInfo: TrafficInfo) => void
): (sbData: SourcebusterData) => void {
  return (sbData: SourcebusterData) => {
    const { typ, src, mdm, cmp, cnt, trm } = sbData.current;

    const trafficInfo: TrafficInfo = {
      type: mapType(typ),
      source: src,
      medium: mdm,
      campaign: cmp,
      content: cnt,
      term: trm,
    };

    callback(trafficInfo);
  };
}

export function setupSourceBuster(
  callback: (trafficInfo: TrafficInfo) => void
): void {
  sbjs.init({
    callback: wrapCallback(callback),

    typein_attributes: {
      source: "direct",
      medium: "none",
    },
    referrals: [
      {
        host: "www.flooringstores.com",
        display: "flooringstores",
        medium: "directory",
      },
      {
        host: "yelp.com",
        display: "yelp",
        medium: "directory",
      },
      {
        host: "facebook.com",
        display: "facebook",
        medium: "social",
      },
      {
        host: "instagram.com",
        display: "instagram",
        medium: "social",
      },
      {
        host: "fb.com",
        display: "facebook",
        medium: "social",
      },
      {
        host: "angieslist.com",
        display: "angieslist",
        medium: "directory",
      },
    ],
  });
}
